import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type IAsset} from '@netx/core-asset-next/schema';
import {assetModifiedMap} from '@netx/core-asset-next/hooks/useAsset';

/**
 * `getAssetBean` request params\
 * (what is used to send to server)
 */
export type GetAssetBeanRequestOptions = {
	id: number;
};

/**
 * `getAssetBean` request\
 * (what gets sent to the server)
 */
export type GetAssetBeanRequest = [GetAssetBeanRequestOptions['id']];

/**
 * `getAssetBean` response\
 * (what comes back from the server)
 */
export type GetAssetBeanResponse = SuccessResponse<GetAssetBeanResult>;

/**
 * `getAssetBean` result\
 * (what is utilized from the server response)
 */
export interface GetAssetBeanResult extends IAsset {}

export const getAssetBeanEndpoint = 'getAssetBean';

/**
 * Get asset bean
 * @param fetchParams Fetch params
 * @param signal Abort signal
 */
export const getAssetBean = async (
	{id}: GetAssetBeanRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetAssetBeanRequest = [id];

	return client
		.post<GetAssetBeanResponse>(getAssetBeanEndpoint, requestParams, {signal})
		.then((response) => {
			const asset = response.data.result;
			const modifiedHack = assetModifiedMap.get(asset.assetId);
			const moddate = modifiedHack
				? new Date(modifiedHack).toISOString()
				: asset.moddate;
			return {
				...asset,
				moddate,
			};
		});
};

export default getAssetBean;
